import React from "react";
import { PageNotFoundScreen } from "../../../../app/screens/PageNotFoundScreen";
import { PrivateRouteDefinition } from "../../../../infecto-lms-webapp/router/interfaces";

export const PageNotFoundRoutes: PrivateRouteDefinition[] = [
	{
		path: "*",
		component: <PageNotFoundScreen />,
	},
];
